import styled from 'styled-components'
import Slider from "react-slick";
import "../../node_modules/slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import { useContext, useEffect } from 'react';
import authContext from '../context/auth-context';

const VideoContainer = styled.div`
    display:flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    iframe{
        border: 1px solid rgba(77,75,50,0.72);
        width:50%; 
        height:400px;
        @media screen and (max-width:1024px){
          width:50%; 
          height:400px;
        }
        @media screen and (max-width:768px){
          width:70%; 
          height:300px;
        }
        @media screen and (max-width:768px){
          width:88%; 
          height:300px;
        }
    }
    button{
        align-self:'center';
        color:white;
        padding:10px;
        background: rgba(77,75,50,0.72);
        border-radius:5px;
        font-weight:500;
        font-size:16px;
        border: 1px solid rgba(77,75,50,0.72);
        transition: all 0.3s ease-in-out;
        &:hover{
            background: #FCDA8B;
            border: 1px solid #FCDA8B;
            color:black;
            font-weight:500;
            cursor:pointer;
        }
    }
    
`
function Carousel () {
    // const settings = {
    //   dots: true,
    //   infinite: carouselData?.length > 5,
    //   speed: 1000,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    // //   autoplay:true
    // }
    const {state, getYoutubeVideoLinks} = useContext(authContext)
    var settings = {
      dots: true,
      speed: 900,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:true,
      infinite: state?.carouselData?.length > 5,
    };
    useEffect(()=>{
      getYoutubeVideoLinks()
      // eslint-disable-next-line
    },[])
      return (
        <div className="container">
          <Slider {...settings}>
              {state?.carouselData?.map((item) => (
                <VideoContainer key={item._id}>
                  <iframe loading='lazy' src={`https://www.youtube.com/embed/${item.videoUrl}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe><br/>
                  <a rel="noreferrer" href='https://www.youtube.com/@Shayanwahedi' target='_blank'>
                      <button >Visit Channel</button>
                  </a>
                </VideoContainer>
              ))}
            </Slider>
        </div>
        
      );
  }

export default Carousel;